import { styled } from '../stitches.config'

export const ForceSingleLineBold = styled('b', {
  whiteSpace: 'nowrap',
})
